(() => {
  if (window.addaxHeaderMenuBound) return;
  window.addaxHeaderMenuBound = true;
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const desktopImages = window.matchMedia('(min-width: 1055px) and (hover: hover) and (pointer: fine)');
  const bound = new WeakSet();
  const editorOpen = new WeakSet();
  let imagePreloadScheduled = false;

  function scheduleImagePreload() {
    if (document.readyState !== 'complete' || !desktopImages.matches || imagePreloadScheduled) return;
    imagePreloadScheduled = true;
    const preload = () => {
      imagePreloadScheduled = false;
      if (!desktopImages.matches) return;
      document.querySelectorAll('header-menu .addax-menu-images img[loading="lazy"]').forEach(image => {
        if (image.complete && image.naturalWidth > 0) return;
        if (image.closest('details[open]')) return;
        image.fetchPriority = 'low';
        image.loading = 'eager';
      });
    };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preload, { timeout: 2000 });
    } else {
      window.setTimeout(preload, 1500);
    }
  }

  function syncHeader(details) {
    const section = details.closest('.section-header');
    section?.classList.toggle('scrolled-past-header-custom', !!section.querySelector('header-menu > details[open]'));
  }

  function close(details) {
    details.open = false;
    details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    details.querySelectorAll('details[open]').forEach(nested => {
      nested.open = false;
      nested.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
    syncHeader(details);
  }

  function open(details) {
    details.querySelectorAll('.addax-menu-images img').forEach(image => {
      if (image.fetchPriority === 'low') image.fetchPriority = 'auto';
    });
    const section = details.closest('.section-header');
    section?.querySelectorAll('header-menu > details[open]').forEach(other => {
      if (other !== details) close(other);
    });
    details.open = true;
    details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    syncHeader(details);
  }

  function init(root) {
    root.querySelectorAll('header-menu > details').forEach(details => {
      if (bound.has(details)) return;
      bound.add(details);
      const summary = details.querySelector('summary');
      if (!summary) return;
      let closeTimer;
      summary.addEventListener('mouseenter', () => {
        if (!desktopHover.matches) return;
        clearTimeout(closeTimer);
        open(details);
      });
      details.addEventListener('mouseenter', () => clearTimeout(closeTimer));
      details.addEventListener('mouseleave', () => {
        if (!desktopHover.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          if (!editorOpen.has(details) && !details.contains(document.activeElement)) close(details);
        }, 150);
      });
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (details.open) open(details);
        else syncHeader(details);
      });
      details.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        clearTimeout(closeTimer);
        editorOpen.delete(details);
        close(details);
        summary.focus();
      });
      details.querySelectorAll('details > summary').forEach(nestedSummary => {
        nestedSummary.addEventListener('mouseenter', () => {
          if (!desktopHover.matches) return;
          nestedSummary.parentElement.open = true;
          nestedSummary.setAttribute('aria-expanded', 'true');
        });
      });
    });
  }

  init(document);
  scheduleImagePreload();
  window.addEventListener('load', scheduleImagePreload, { once: true });
  desktopImages.addEventListener('change', scheduleImagePreload);
  document.addEventListener('shopify:section:load', event => {
    init(event.target);
    scheduleImagePreload();
  });
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('header-menu > details');
    if (!details) return;
    editorOpen.add(details);
    open(details);
  });
  document.addEventListener('shopify:block:deselect', event => {
    const details = event.target.closest('header-menu > details');
    if (!details) return;
    editorOpen.delete(details);
    close(details);
  });
})();
